module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/258-mongolia-12c1f9e98b0e88953bbab0f62755fecf.svg";